import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import VehiclePosition from './vehicle-position';
import VehiclePositionDetail from './vehicle-position-detail';
import VehiclePositionUpdate from './vehicle-position-update';
import VehiclePositionDeleteDialog from './vehicle-position-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={VehiclePositionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={VehiclePositionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={VehiclePositionDetail} />
      <ErrorBoundaryRoute path={match.url} component={VehiclePosition} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={VehiclePositionDeleteDialog} />
  </>
);

export default Routes;
